import { RegionShared } from "@1games-ru/region-shared";
import { useEffect, useState } from "react";
import rpc from "@1games-ru/rage-rpc";
import useAppDispatch from "@/core/helpers/useAppDispatch";
import useAppSelector from "@/core/helpers/useAppSelector";
import {
  personalDataSelector,
  setConfig,
  setHair,
  setHats,
  setLegs,
  setShoes,
  setTops,
} from "@/domains/createCharacter/slice";
import parseConfig from "@/domains/createCharacter/helpers/parseConfig";
import useCreateCharacter from "@/domains/createCharacter/hooks/useCreateCharacter";

export default function useShowCreateCharacter() {
  const { initCharacter } = useCreateCharacter();
  const dispatch = useAppDispatch();
  const personalData = useAppSelector(personalDataSelector);
  const [isShow, setIsShow] = useState(false);
  useEffect(() => {
    rpc.register(
      RegionShared.Client.Events.Account.CreateCharacterShow,
      async (data: typeof RegionShared.Client.Requests.CreateCharacterShowRequest) => {
        setIsShow(true);
        await initCharacter();
        const genderData = parseConfig(data.config);

        dispatch(setConfig(genderData));

        dispatch(setHair(genderData[personalData.gender].hairs[0]));
        dispatch(setHats(genderData[personalData.gender].hats[0]));
        dispatch(setTops(genderData[personalData.gender].tops[0]));
        dispatch(setLegs(genderData[personalData.gender].legs[0]));
        dispatch(setShoes(genderData[personalData.gender].shoes[0]));
      },
    );

    return () => {
      rpc.unregister(RegionShared.Client.Events.Account.CreateCharacterShow);
    };
  }, []);

  useEffect(() => {
    rpc.register(RegionShared.Client.Events.Account.CreateCharacterHide, () => {
      setIsShow(false);
    });

    return () => {
      rpc.unregister(RegionShared.Client.Events.Account.CreateCharacterHide);
    };
  }, []);

  return { isShow };
}
